import { styled, useTheme } from "@mui/system";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import React from "react";

const StyledTextFieldWrapper = styled((props) => {
  const { column, error, theme, errorColor, disabled, ...other } = props;

  return (
    <TextField
      multiline
      maxRows={4}
      fullWidth
      disabled={disabled}
      InputLabelProps={{ shrink: true }}
      label={
        column ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {column.headerName}
            <Tooltip title={column.description || ""}>
              <IconButton size="small" sx={{ marginLeft: 1 }}>
                <HelpOutlineOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        ) : (
          ""
        )
      }
      variant="outlined"
      error={error}
      {...other}
    />
  );
})(({ error, errorColor }) => ({
  marginBottom: "24px",
  "& label.Mui-focused": {
    color: error ? errorColor : "#A0AAB4",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: error ? errorColor : "#E0E3E7",
    },
    "&:hover fieldset": {
      borderColor: error ? errorColor : "#B2BAC2",
    },
    "&.Mui-focused fieldset": {
      borderColor: error ? errorColor : "#6F7E8C",
    },
  },
}));

export const StyledTextField = (props) => {
  const { column, error, ...other } = props;
  const theme = useTheme();
  const errorColor = theme.palette.error.main;

  return (
    <StyledTextFieldWrapper
      theme={theme}
      error={error}
      errorColor={errorColor}
      column={column}
      {...other}
    />
  );
};
